module.exports = __webpack_public_path__ + "img/Profile_logo.334f5743.png";